/**
 * Stats.
 *
 * @param {Object} params - Stats API object
 * @param {number} params.left - How many users have left the queue
 * @param {number} params.processed - How many users have passed the queue
 * @param {number} params.timestamp - Time
 * @param {number} params.waiting - How many users are currently waiting
 */
import { BaseAPIModel } from '@weezevent/weezjs-core';

export default class StatsQueueModel extends BaseAPIModel {
    fields() {
        return {
            id: { readOnly: true, primaryKey: true }
        };
    }

    static listUrl({ organizationId, eventId, widgetKey = null }) {
        if (!organizationId && !eventId && !widgetKey) {
            return `/ticket/queues/stats?start=${parseInt(Date.now() / 1000) - 1800}`;
        }

        if (widgetKey) {
            return `/ticket/organizations/${organizationId}/widget/${widgetKey}/queues/stats?start=${parseInt(Date.now() / 1000) - 1800}`;
        }

        return `/ticket/organizations/${organizationId}/events/${eventId}/queues/stats?start=${parseInt(Date.now() / 1000) - 1800}`;
    }

    /**
     * Gets the url for this object(s)
     */
    static getItemUrl(...args) {
        return `${this.getListUrl(args[0])}`;
    }
}
